"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdLaravelAppdefs = require("cccisd-laravel-appdefs");
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _cccisdTableRenders = _interopRequireDefault(require("cccisd-table-renders"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _cccisdStyleBible = _interopRequireDefault(require("cccisd-style-bible"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // import TableTop from "cccisd-tabletop";
var rendersContext = require.context('resources/assets/js', true, /^\.\/renders\/([^/]+\/){1}index\.js$/);
var Deployment = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(Deployment, _React$Component);
  function Deployment() {
    var _this;
    _classCallCheck(this, Deployment);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Deployment, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "checkFlowProgress", function (list) {
      list.forEach(function (student) {});
    });
    _defineProperty(_assertThisInitialized(_this), "getRenderFromContext", function (type) {
      var foundKey = (0, _find2["default"])(rendersContext.keys(), function (key) {
        var renderType = key.replace(/^.*\/[^/]+\/([^/]+)\/index\.js$/, '$1');
        return type === renderType;
      });
      if (foundKey) {
        return rendersContext(foundKey)["default"];
      }
      console.warn("App renderer not found for \"".concat(type, "\" in app"));
      return undefined;
    });
    _defineProperty(_assertThisInitialized(_this), "processTable", function () {
      var table = _this.props.deploymentSettings.tableSettings;
      var cols = table.columns.map(function (c) {
        var column = {};
        if ('renderAs' in c) {
          var renderClass = function renderClass() {};
          if (c.renderAs["class"] === 'app') {
            var tmpRender = _this.getRenderFromContext(c.renderAs.type);
            if (tmpRender) {
              renderClass = tmpRender;
            }
          } else {
            renderClass = _cccisdTableRenders["default"][c.renderAs["class"]][c.renderAs.type];
          }
          column.render = renderClass(c.renderAs.settings);
          column = _objectSpread(_objectSpread({}, column), (0, _cccisdLaravelAppdefs.setAppdefEnumFilterSettings)(c, column));
        }
        return _objectSpread(_objectSpread({}, c), column);
      });
      var variables = table.requiredVariables ? _this.processVariables(table.requiredVariables) : {};
      return _objectSpread(_objectSpread({}, (0, _omit2["default"])(table, ['requiredVariables'])), {}, {
        columns: cols,
        graphqlVariables: variables
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleMixedVars", function (fromProps, otherVars) {
      var propVars = {};
      var variables = {};
      if (!(0, _isEmpty2["default"])(fromProps) && fromProps.some(function (item) {
        return item.variable === 'pawnId';
      })) {
        propVars.pawnId = _this.props.pawn.pawn.pawnId;
      }
      if (!(0, _isEmpty2["default"])(otherVars)) {
        variables = (0, _cccisdLaravelAppdefs.queryVariablesHelper)(otherVars);
      }
      return _objectSpread(_objectSpread({}, variables), propVars);
    });
    _defineProperty(_assertThisInitialized(_this), "processVariables", function (array) {
      var variables = {};
      var newArray = [];
      var noFrom = array.every(function (item) {
        return (0, _isNil2["default"])(item.from);
      });
      if (noFrom) {
        variables = (0, _cccisdLaravelAppdefs.queryVariablesHelper)(array);
      } else {
        var fromProps = [];
        array.forEach(function (item) {
          if (item.from) {
            if (item.from === 'props') {
              fromProps.push(item);
            } else {
              newArray.push(item);
            }
          } else {
            newArray.push(item);
          }
        });
        variables = _this.handleMixedVars(fromProps, newArray);
      }
      return variables;
    });
    return _this;
  }
  _createClass(Deployment, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _cccisdStyleBible["default"][this.props["class"]]
      }, /*#__PURE__*/_react["default"].createElement("h2", null, this.props.deploymentSettings.pageTitle), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: this.props.deploymentSettings.pageDescription
      })), /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], this.processTable()));
    }
  }]);
  return Deployment;
}(_react["default"].Component);
_defineProperty(Deployment, "propTypes", {
  deploymentSettings: _propTypes["default"].object.isRequired,
  "class": _propTypes["default"].string,
  pawn: _propTypes["default"].object
});
_defineProperty(Deployment, "defaultProps", {
  "class": ''
});